import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhoIsForSection() {
  const isFor = ['Profesionales que no dejan de pensar en el trabajo al acostarse.', 'Estudiantes bajo alta presión que sufren de ansiedad pre-examen.', 'Personas que se sienten "cansadas pero cableadas" (exhaustas pero alerta).', 'Quienes han probado técnicas de relajación y sintieron que "no son para ellos".'];
  const isNotFor = ['Personas que buscan una "pastilla mágica" sin cambiar un solo hábito.', 'Quienes sufren de apnea del sueño u otros trastornos puramente fisiológicos.', 'Personas que no están dispuestas a dedicar 10 minutos a su rutina nocturna.'];
  return <section className="relative z-10 py-24 px-4 bg-[#0a0e27]/80" data-id="element-163">
      <div className="max-w-5xl mx-auto" data-id="element-164">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-165">
          {/* IS FOR */}
          <FadeIn direction="right" data-id="element-166">
            <div className="glass-card p-8 border-green-500/20 bg-green-900/5 h-full" data-id="element-167">
              <h3 className="text-2xl font-bold text-white mb-8 font-serif flex items-center gap-3" data-id="element-168">
                <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-169">
                  <CheckIcon className="w-5 h-5 text-green-400" data-id="element-170" />
                </div>
                Esto ES Para Ti Si...
              </h3>
              <ul className="space-y-6" data-id="element-171">
                {isFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-172">
                    <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-173" />
                    <span className="text-gray-300 leading-relaxed" data-id="element-174">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* IS NOT FOR */}
          <FadeIn direction="left" delay={0.2} data-id="element-175">
            <div className="glass-card p-8 border-rose-500/20 bg-rose-900/5 h-full" data-id="element-176">
              <h3 className="text-2xl font-bold text-white mb-8 font-serif flex items-center gap-3" data-id="element-177">
                <div className="w-8 h-8 rounded-full bg-rose-500/20 flex items-center justify-center" data-id="element-178">
                  <XIcon className="w-5 h-5 text-rose-400" data-id="element-179" />
                </div>
                Esto NO Es Para Ti Si...
              </h3>
              <ul className="space-y-6" data-id="element-180">
                {isNotFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-181">
                    <XIcon className="w-6 h-6 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-182" />
                    <span className="text-gray-300 leading-relaxed" data-id="element-183">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}